import { useSpeciesOnlyForContext } from '@/hooks/species/useSpeciesOnlyForContext';
import { createContext } from 'react';

// Context that provides all the species data functionality
const SpeciesContext = createContext<
	ReturnType<typeof useSpeciesOnlyForContext>
>({
	species: undefined,
	speciesSortedByName: [],
	isLoading: false,
	error: undefined,
	findSpeciesById: () => undefined,
	findSpeciesBySlug: () => undefined,
	getMainImageById: () => undefined,
	getSpeciesRouteById: () => '/',
	getSpeciesSupportsAudioRecognition: () => false,
});

export default SpeciesContext;
